import * as L from 'leaflet';
import * as React from "react";
import MapView from './MapView'

L.Icon.Default.imagePath = '//cdnjs.cloudflare.com/ajax/libs/leaflet/1.3.1/images/'

const MapLayout = () => (
  <div>
    <MapView />
  </div>
)
export default MapLayout


// WEBPACK FOOTER //
// ./src/map/MapLayout.tsx